(() => {
  const SEC_SEL = '.shopify-section';
  const SRC_SEL = '.background,[class*="color-"],[class*="scheme"],[data-color-scheme]';

  const isTransparent = (v) =>
    !v || v === 'transparent' || v === 'rgba(0, 0, 0, 0)';

  // 前回適用した値を覚えて、変化がなければ何もしない（超重要）
  const cache = new WeakMap();

  const syncOne = (sec) => {
    const src = sec.querySelector(SRC_SEL);
    if (!src) return;

    const cs = getComputedStyle(src);
    const img = cs.backgroundImage;
    const col = cs.backgroundColor;

    const next = (img && img !== 'none')
      ? `img:${img}|col:${col}`
      : (!isTransparent(col) ? `col:${col}` : '');

    if (!next) return;

    const prev = cache.get(sec);
    if (prev === next) return; // 変化なし→スキップ
    cache.set(sec, next);

    if (img && img !== 'none') {
      sec.style.backgroundImage = img;
      if (!isTransparent(col)) sec.style.backgroundColor = col;
    } else {
      sec.style.backgroundColor = col;
      sec.style.backgroundImage = 'none';
    }
  };

  const syncAll = (root = document) => {
    (root.querySelectorAll ? root : document).querySelectorAll(SEC_SEL).forEach(syncOne);
  };

  const ready = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else fn();
  };

  // rAFで間引き（連打でも1フレーム1回）
  let raf = 0;
  const kick = (root) => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      syncAll(root);
    });
  };

  // 初回
  ready(() => syncAll());

  // テーマエディタ
  document.addEventListener('shopify:section:load', (e) => kick(e.target));
  document.addEventListener('shopify:section:reorder', () => kick());

  // ✅ ここが肝：body全体は監視しない。各section内だけ監視する。
  const observeSections = () => {
    document.querySelectorAll(SEC_SEL).forEach((sec) => {
      if (sec.__apBgObserved) return;
      sec.__apBgObserved = true;

      // タブ切替は「内部のDOM差し替え」が多いので childList/subtree だけで十分なことが多い
      new MutationObserver(() => kick(sec)).observe(sec, {
        childList: true,
        subtree: true
        // attributes は重くなりやすいので基本OFF（必要になったら下の行を復活）
        // ,attributes: true, attributeFilter: ['class','style']
      });
    });
  };

  ready(observeSections);
  // セクションが後から増えるテーマ/アプリ対策：軽く再スキャン
  ready(() => setTimeout(observeSections, 500));
})();









// ブログ記事カードのタイトル高さを統一
(() => {
  const equalizeTitles = (container) => {
    // コンテナ内のすべてのタイトル要素を取得
    const titles = container.querySelectorAll('.article-card__title');
    if (titles.length === 0) return;

    // まず、すべてのタイトルの高さをリセット
    titles.forEach(title => {
      title.style.height = 'auto';
    });

    // レイアウトが確定するまで少し待つ
    requestAnimationFrame(() => {
      // タイトルの位置（top値）を使用して行ごとにグループ化
      const rows = new Map();
      titles.forEach(title => {
        const rect = title.getBoundingClientRect();
        // 同じ行とみなすための許容誤差（10px）
        const rowKey = Math.round(rect.top / 10) * 10;
        
        if (!rows.has(rowKey)) {
          rows.set(rowKey, []);
        }
        rows.get(rowKey).push(title);
      });

      // 各行のタイトルの最大高さを計算して適用
      rows.forEach(titleElements => {
        if (titleElements.length <= 1) return;

        // 最大の高さを取得
        const maxHeight = Math.max(...titleElements.map(title => title.offsetHeight));

        // すべてのタイトルに最大高さを適用
        titleElements.forEach(title => {
          title.style.height = `${maxHeight}px`;
        });
      });
    });
  };

  const initTitleEqualization = () => {
    // ブログ記事コンテナを取得
    const containers = document.querySelectorAll('.blog-articles, .blog__posts, .articles-wrapper');
    
    containers.forEach(container => {
      equalizeTitles(container);
    });
  };

  const ready = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    // レイアウトが確定してから実行
    setTimeout(() => {
      initTitleEqualization();
    }, 200);

    // リサイズ時にも再計算
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('.article-card__title').forEach(title => {
          title.style.height = 'auto';
        });
        setTimeout(() => {
          initTitleEqualization();
        }, 200);
      }, 250);
    });

    // 動的に追加されるコンテンツにも対応（ロードモアなど）
    const observer = new MutationObserver(() => {
      setTimeout(() => {
        initTitleEqualization();
      }, 200);
    });

    ready(() => {
      document.querySelectorAll('.blog-articles, .blog__posts, .articles-wrapper').forEach(container => {
        observer.observe(container, { childList: true, subtree: true });
      });
    });
  });
})();




document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);

  const product = params.get('product');
  const url = params.get('url');
  const img = params.get('img');

  if (!product && !url && !img) return;

  const container = document.getElementById('contact-related-product');
  if (!container) return;

  const decode = (v) => {
    try { return decodeURIComponent(v); } catch(e) { return v; }
  };

  if (product) {
    const p = decode(product);
    const titleEl = document.getElementById('contact-product-title');
    if (titleEl) titleEl.textContent = p;

    const hiddenProduct = document.getElementById('contact-hidden-product');
    if (hiddenProduct) hiddenProduct.value = p;
  }

  if (url) {
    const u = decode(url);
    const linkEl = document.getElementById('contact-product-link');
    if (linkEl) linkEl.href = u;

    const hiddenUrl = document.getElementById('contact-hidden-url');
    if (hiddenUrl) hiddenUrl.value = u;
  }

  if (img) {
    const i = decode(img);
    const imgEl = document.getElementById('contact-product-img');
    if (imgEl) imgEl.src = i;

    const hiddenImg = document.getElementById('contact-hidden-img');
    if (hiddenImg) hiddenImg.value = i;
  }

  container.style.display = 'block';
});




/* AP追加箇所：スマホ用ヘッダー下の検索窓（search-modal.js の変更分を add-ap.js に集約） */
(function () {
	const MOBILE_BREAKPOINT = 750;

	function isMobile() {
		return window.innerWidth <= MOBILE_BREAKPOINT;
	}

	const DROPDOWN_DURATION_MS = 500; // --duration-long に合わせる

	function openHeaderSearchDropdown() {
		const dropdown = document.getElementById("header-search-dropdown");
		if (!dropdown) return;
		dropdown.removeAttribute("hidden");
		document.body.classList.add("overflow-hidden");
		// 1フレーム待ってから is-open を付与し、上からスライドインのトランジションを再生
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				dropdown.classList.add("is-open");
				const input = dropdown.querySelector(".header-search-dropdown__input");
				if (input) {
					setTimeout(function () {
						input.focus();
					}, 100);
				}
			});
		});
	}

	function closeHeaderSearchDropdown() {
		const dropdown = document.getElementById("header-search-dropdown");
		if (!dropdown) return;
		if (dropdown.classList.contains("is-closing")) return;
		dropdown.classList.add("is-closing");
		let done = false;
		const onEnd = () => {
			if (done) return;
			done = true;
			dropdown.setAttribute("hidden", "");
			dropdown.classList.remove("is-open", "is-closing");
			document.body.classList.remove("overflow-hidden");
		};
		const inner = dropdown.querySelector(".header-search-dropdown__inner");
		if (inner) {
			inner.addEventListener("transitionend", onEnd, { once: true });
		}
		setTimeout(onEnd, DROPDOWN_DURATION_MS + 100);
	}

	function isHeaderSearchDropdownOpen() {
		const dropdown = document.getElementById("header-search-dropdown");
		return dropdown && dropdown.classList.contains("is-open");
	}

	function initHeaderSearchDropdown() {
		// 検索トリガー：スマホ時はモーダルではなくヘッダー下の検索窓を開く（キャプチャで先に処理）
		document.removeEventListener("click", onSearchTriggerClick, true);
		document.addEventListener("click", onSearchTriggerClick, true);

		// ヘッダー検索窓の閉じるボタン（委譲）
		document.body.removeEventListener("click", onCloseHeaderSearchClick);
		document.body.addEventListener("click", onCloseHeaderSearchClick);
	}

	function onSearchTriggerClick(e) {
		const isTrigger = e.target.closest(".search-modal-trigger");
		const isOverlayOrClose = e.target.closest(".search-modal__overlay, .search__close, .header__modal-close-search-button");

		// スマホ：検索トリガー → ヘッダー下の検索窓を開閉
		if (isTrigger && isMobile()) {
			e.preventDefault();
			e.stopPropagation();
			if (isHeaderSearchDropdownOpen()) {
				closeHeaderSearchDropdown();
			} else {
				openHeaderSearchDropdown();
			}
			return;
		}
		// スマホで検索窓が開いているときのオーバーレイ・閉じるボタン → 検索窓だけ閉じる
		if (isMobile() && isHeaderSearchDropdownOpen() && isOverlayOrClose) {
			e.preventDefault();
			e.stopPropagation();
			closeHeaderSearchDropdown();
			return;
		}
		// PC：何もせずイベントを通過させる（search-modal.js がデフォルトでモーダルを開閉）
	}

	function onCloseHeaderSearchClick(e) {
		if (!e.target.closest("[data-close-header-search], .header-search-dropdown__close")) return;
		if (!isHeaderSearchDropdownOpen()) return;
		e.preventDefault();
		closeHeaderSearchDropdown();
	}

	document.addEventListener("keyup", function (e) {
		if (e.key !== "Escape") return;
		// スマホ：検索窓が開いていれば閉じる
		if (isMobile() && isHeaderSearchDropdownOpen()) {
			closeHeaderSearchDropdown();
		}
		// PC：Escape は search-modal.js が検索モーダルを閉じる
	});

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initHeaderSearchDropdown);
	} else {
		initHeaderSearchDropdown();
	}
	document.addEventListener("shopify:section:load", initHeaderSearchDropdown);
})();

// 検索モーダル：開くときは is-opening → rAF で active を付与してスライドイン再生、閉じるときは is-closing でアニメ後に active を外す
(() => {
	const MODAL_ID = "search-modal";
	const DURATION_MS = 500; // --duration-long に合わせる
	const PC_BREAKPOINT = 750;

	function isPc() {
		return window.innerWidth > PC_BREAKPOINT;
	}

	function isSearchModalActive() {
		const modal = document.getElementById(MODAL_ID);
		return modal && modal.classList.contains("active");
	}

	function openSearchModalWithAnimation() {
		const modal = document.getElementById(MODAL_ID);
		if (!modal) return;
		modal.classList.add("is-opening");
		document.body.classList.add("overflow-hidden");
		document.querySelector(".header-overlay")?.classList.add("color-background-1");
		document.querySelector(".header__modal-close-search-button")?.classList.add("active");
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				modal.classList.remove("is-opening");
				modal.classList.add("active");
				const input = modal.querySelector(".search__input");
				if (input) setTimeout(() => input.focus(), 50);
			});
		});
	}

	function closeSearchModalAfterAnimation() {
		const modal = document.getElementById(MODAL_ID);
		if (!modal) return;
		modal.classList.add("is-closing");
		let done = false;
		const onEnd = () => {
			if (done) return;
			done = true;
			modal.classList.remove("active", "is-closing");
			document.querySelector(".header-overlay")?.classList.remove("color-background-1");
			document.body.classList.remove("overflow-hidden");
			document.querySelector(".header__modal-close-search-button")?.classList.remove("active");
			const trigger = document.querySelector(".search-modal-trigger");
			if (trigger) trigger.focus();
		};
		modal.addEventListener("transitionend", onEnd, { once: true });
		setTimeout(onEnd, DURATION_MS + 100);
	}

	function onSearchModalClick(e) {
		const isTrigger = e.target.closest(".search-modal-trigger");
		const isOverlayOrClose = e.target.closest(".search-modal__overlay, .search__close, .header__modal-close-search-button");
		if (isPc() && isTrigger && !isSearchModalActive()) {
			e.preventDefault();
			e.stopImmediatePropagation();
			openSearchModalWithAnimation();
			return;
		}
		if (isSearchModalActive() && (e.key === "Escape" || isOverlayOrClose)) {
			e.preventDefault();
			e.stopImmediatePropagation();
			closeSearchModalAfterAnimation();
		}
	}

	function init() {
		document.removeEventListener("click", onSearchModalClick, true);
		document.addEventListener("click", onSearchModalClick, true);
		document.removeEventListener("keyup", onSearchModalClick, true);
		document.addEventListener("keyup", onSearchModalClick, true);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
	document.addEventListener("shopify:section:load", init);
})();

// メニュードロワー（menu-drawer）：×ボタンで閉じるときも左にスライドアウトさせてから閉じる
(() => {
	const DURATION_MS = 500; // --duration-long に合わせる

	function closeMenuDrawerWithAnimation(button) {
		const details = button.closest(".menu-drawer-container");
		if (!details) return;
		const drawer = details.querySelector(".menu-drawer");
		const headerDrawer = details.closest("header-drawer");
		const breakpoint = headerDrawer?.dataset?.breakpoint || "tablet";
		if (!drawer) {
			details.removeAttribute("open");
			document.body.classList.remove(`overflow-hidden-${breakpoint}`);
			return;
		}

		// 既に閉じアニメ中なら何もしない
		if (drawer.classList.contains("ap-menu-closing")) return;

		// 左にスライドアウトさせるクラスを付与
		drawer.classList.add("ap-menu-closing");

		let done = false;
		const finish = () => {
			if (done) return;
			done = true;
			drawer.classList.remove("ap-menu-closing");
			document.body.classList.remove(`overflow-hidden-${breakpoint}`);
			details.removeAttribute("open");
		};

		drawer.addEventListener("transitionend", finish, { once: true });
		setTimeout(finish, DURATION_MS + 100);
	}

	function onClick(e) {
		const btn = e.target.closest("[data-close-menu-drawer]");
		if (!btn) return;
		e.preventDefault();
		closeMenuDrawerWithAnimation(btn);
	}

	function init() {
		document.removeEventListener("click", onClick, true);
		document.addEventListener("click", onClick, true);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
	document.addEventListener("shopify:section:load", init);
})();


// ── sort-wrapper の DOM 移動は廃止 ──
// CSS（.collection-wrapper--vertical .facets__sort-wrapper_vertical）で絶対配置するため JS 移動不要。
// DOM 移動すると sort select が form 外に出てしまい、AJAX ソート・フィルターが壊れるため削除。


// ── コレクションページのデフォルトソートを「新しい順」に変更 ──
// sort_by が URL に指定されていない場合のみ created-descending にリダイレクト
(() => {
  const params = new URLSearchParams(window.location.search);
  if (!params.has('sort_by') && document.querySelector('select[name="sort_by"]')) {
    params.set('sort_by', 'created-descending');
    const url = new URL(window.location.href);
    url.search = params.toString();
    window.location.replace(url.toString());
  }
})();


// ── SortBy から「おすすめ順」「ベストセラー順」を除去 ──
// CSS の display:none は <option> に効かないブラウザがあるため JS で削除する
// AJAX（renderProductGridContainer）で select が再生成されることがあるため MutationObserver を使用
(() => {
  const HIDDEN_VALUES = ['manual', 'best-selling'];

  function removeSortOptions() {
    document.querySelectorAll('select[name="sort_by"]').forEach((select) => {
      // 不要な選択肢を削除
      HIDDEN_VALUES.forEach((val) => {
        const opt = select.querySelector(`option[value="${val}"]`);
        if (opt) opt.remove();
      });
      // 「新しい順」を先頭に移動
      const newest = select.querySelector('option[value="created-descending"]');
      if (newest) select.prepend(newest);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeSortOptions);
  } else {
    removeSortOptions();
  }

  // AJAX フィルタ後に #ProductGridContainer が差し替わる場合に対応
  const container = document.getElementById('ProductGridContainer');
  if (container) {
    new MutationObserver(removeSortOptions).observe(container, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', removeSortOptions);
})();


// ── facets アコーディオン ──
// document委譲方式：AJAX（renderFilters）でDOMが差し替えられても動作し続ける
(() => {
  document.addEventListener('click', (e) => {
    const header = e.target.closest('.facets__disclosure-header');
    if (!header) return;
    if (e.target.closest('.facets__reset')) return; // リセットリンクは除外

    const display = header.nextElementSibling;
    if (!display || !display.classList.contains('facets__display')) return;

    display.classList.toggle('is-open');
  });
})();

// RECOMMENDATIONS スマホスライダー
(function () {
  if (!document.querySelector('.article-template__recommendations')) return;

  const MOBILE_BREAKPOINT = 990;

  const initRecommendationsSlider = () => {
    const sections = document.querySelectorAll('.article-template__recommendations');

    sections.forEach((section) => {
      const swiperEl = section.querySelector('.recommendations-swiper');
      if (!swiperEl) return;

      new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 4.5,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        pagination: {
          el: section.querySelector('.recommendations-pagination'),
          clickable: true,
        },
        breakpoints: {
          [MOBILE_BREAKPOINT]: {
            slidesPerView: 4,
            spaceBetween: 5,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    initRecommendationsSlider();
    document.addEventListener('shopify:section:load', initRecommendationsSlider);
  });
})();


// AP追加: セクション見出しのスクロールトリガー slide-up アニメーション
(function () {
  function initScrollSlideUp() {
    var items = document.querySelectorAll('.scroll-slide-up');
    if (!items.length) return;
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    // 二重rAFで初期状態(translateY)をブラウザが描画してから監視開始
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        items.forEach(function (el) {
          observer.observe(el);
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollSlideUp);
  } else {
    initScrollSlideUp();
  }
  document.addEventListener('shopify:section:load', initScrollSlideUp);
})();
// /AP追加

// AP追加: collection-tabs カード左から順にふわっと表示
(function () {
  function triggerCardsAnimation(cardItem) {
    if (!cardItem) return;
    cardItem.classList.remove('cards-animated');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        cardItem.classList.add('cards-animated');
      });
    });
  }

  function initCollectionTabsAnimation() {
    document.querySelectorAll('.collection-tabs').forEach(function (section) {
      // タブクリック時：切り替え先のカードをアニメーション
      section.querySelectorAll('[data-tab-target]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = section.querySelector(tab.dataset.tabTarget);
          triggerCardsAnimation(target);
        });
      });

      // カード群を直接監視：30%見えてからアニメーション開始
      // rootMargin でビューポート下端より60px内側に入ってから発火
      var activeItem = section.querySelector('.collection-tabs_card-item.active');
      if (!activeItem) return;
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            triggerCardsAnimation(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -60px 0px' });
      observer.observe(activeItem);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionTabsAnimation);
  } else {
    initCollectionTabsAnimation();
  }
  document.addEventListener('shopify:section:load', initCollectionTabsAnimation);
})();
// /AP追加
